<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Select from 'dashboard/components-next/select/Select.vue';

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  stages: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: [String, Number],
    default: 'all',
  },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();

const itemsByStage = computed(() =>
  props.items.reduce((counts, item) => {
    const stageId = String(item.pipeline_stage || item.stage || 'unknown');
    return {
      ...counts,
      [stageId]: (counts[stageId] || 0) + 1,
    };
  }, {})
);

const stageOptions = computed(() => [
  {
    value: 'all',
    label: t('PIPELINE.BULK_ACTIONS.STAGE_FILTER.ALL', {
      count: props.items.length,
    }),
  },
  ...props.stages.map(stage => {
    const stageId = String(stage.id);
    const count = itemsByStage.value[stageId] || 0;
    return {
      value: stageId,
      label: t('PIPELINE.BULK_ACTIONS.STAGE_FILTER.ONLY_STAGE', {
        stage: stage.name,
        count,
      }),
      disabled: count === 0,
    };
  }),
]);

const selectedStage = computed({
  get: () => String(props.modelValue),
  set: value => emit('update:modelValue', value),
});
</script>

<template>
  <div class="space-y-1 [&>div]:w-full [&_select]:min-h-11 [&_select]:w-full">
    <label
      for="bulk-stage-filter"
      class="block text-sm font-medium text-n-slate-12"
    >
      {{ t('PIPELINE.BULK_ACTIONS.STAGE_FILTER.LABEL') }}
    </label>
    <Select
      v-model="selectedStage"
      input-id="bulk-stage-filter"
      name="pipeline_stage"
      :options="stageOptions"
    />
  </div>
</template>
